import { render, staticRenderFns } from "./ModelManage.vue?vue&type=template&id=802b77ca&scoped=true&"
import script from "./ModelManage.vue?vue&type=script&lang=js&"
export * from "./ModelManage.vue?vue&type=script&lang=js&"
import style0 from "./ModelManage.vue?vue&type=style&index=0&id=802b77ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802b77ca",
  null
  
)

export default component.exports